// commands
// mdfind "com_apple_xcode_dsym_uuids == 52298827-0F70-49FA-9559-F1FA1FB1DED3"
// ffmpeg -i intro.mov -c:v libx264 -crf 19 -strict experimental intro.mp4
// ffmpeg -ss 00:00:30.0 -i intro.mp4 -c copy -t 00:00:10.0 heroIntro.mp4
// ffmpeg -i intro.mov -filter:v "crop=1740:1300:0:0" intro1.mov
// ffmpeg -i heroIntro.mp4 -ss 00:00:1.0 -vframes 1 heroIntroCover.png
// npm run babel -- ./data/things.js
// firebase deploy --only functions
// firebase functions:config:set gmail.email="myusername@gmail.com" gmail.password="secretpassword"
// firebase => settings => firebase admin sdk
// instruments -s devices
// source $HOME/.bash_profile
// adb devices
// serverless logs -f signUpEmail
// git tag v1.4 && git push origin v1.4
// serverless encrypt --stage dev --password ""
// serverless decrypt --stage dev --password ""
// emulator -avd Nexus_5X_API_28_x86
// serverless config credentials --provider aws --key --secret

// statistic
// https://analytics.google.com/analytics/web/#/report-home/a123659942w181963914p179744399
// https://gist.github.com/ButuzGOL/3c31b57c708ae0cf06d9c4394f80364b
// https://play.google.com/apps/publish/?account=8131124734848631597#StatisticsPlace:p=com.butuzgol.stormfire&appid=4976293285342572405
// https://analytics.itunes.apple.com/#/overview?interval=r&datesel=d30&pmeasure=units&tmeasure=units&app=1391894511
// https://console.firebase.google.com/u/0/project/game-2662d/overview

// urls
// https://game-dev-7995e.firebaseapp.com/

// design
// https://assetstore.unity.com/packages/2d/gui/classic-rpg-gui-160253#content
// https://assetstore.unity.com/packages/2d/gui/icons/500-armor-icons-vol-2-157855

// release
// ! update backend server (prod) and update config
// ! do need to update db rules
// ! do need to update images
// ! do need to update data
// ! clean test data

// ! screenshots
// ! demo video

// next
// check i18n is synced
// run unit tests
// run smoke tests
// run types check
// web deploy
// test
// ! - testflight
// ! - web
// update version
// release info
// write release info (discord)
// git tag v1.4 && git push origin v1.4
// update config if required
 
// Release 1.16.0
// ! adv banners

// Release 1.17.0
// ! add images with real payments
// ! add two images only apple pay
// ! add new api env /dev
// ! finish with apple payment

// Release 1.18.0
// ! add islands
// ! add building teleport

// Release 1.19.0
// ! check iap
// ! add big boses
// ! add test user with money and do test teleport
// ! check bots coordinates
// ! add cape for bots
// ! add copy from info username

// Release 1.20.0
// add quests
// iap skrolls

// Backlog
// update intro with new island
// update avatars to make it bigger
// private button
// new message notification
// combats past/current
// reddit

// new class magic
// big boseses
// new islands
// new buildings
// quests
// smart bots
// promotion (reggit, adv, video)
// game center

// Creds
// stormfire@sf.com
// seller@sf.com
// SFQwerty123@
// tester@sf.com/SFTester123@
// crithero@gmail.com
// qwerty123

// open ios/StormFire.xcworkspace
// Login Settings -> Developer -> Sandbox
// butuzgol0@outlook.com / Sf123456@ 

import 'babel-polyfill';
import { Buffer } from 'buffer';

import { AppRegistry } from 'react-native';
import { IS_WEB } from './src/lib/appConstants';

import TextEncodingPolyfill from 'text-encoding';

global.prod = false;
// global.tf = true;
// global.devDb = true;
console.disableYellowBox = true;
global.Buffer = Buffer;
global.TextEncoder = TextEncodingPolyfill.TextEncoder;
global.TextDecoder = TextEncodingPolyfill.TextDecoder;

const App = require('./src/components/App').default;

export default App;

AppRegistry.registerComponent('game', () => App);

if (IS_WEB) {
  AppRegistry.runApplication('game', {
    rootTag: document.getElementById('root'),
  });
}
